import type { UserRoleAssignment } from '@gat-ship/types'

/**
 * Functional core — collection-level operations on `UserRoleAssignment[]`.
 *
 * Pure list→list transforms for the user-role-assignment SignalR handlers. The
 * shell (`useUserRoleAssignments`) reads the event payload and assigns the
 * result; these functions never touch a ref or mutate their input.
 */

/** Append a role assignment to the list. Returns a new array. */
export function appendRoleAssignment(
  assignments: readonly UserRoleAssignment[],
  assignment: UserRoleAssignment
): UserRoleAssignment[] {
  return [...assignments, assignment]
}

/** Remove the assignment with `roleAssignmentId`. No-op when absent. */
export function removeRoleAssignmentById(
  assignments: readonly UserRoleAssignment[],
  roleAssignmentId: string
): UserRoleAssignment[] {
  return assignments.filter(
    (assignment) => assignment.roleAssignmentId !== roleAssignmentId
  )
}
